import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ReserveBonus from 'components/ReserveBonus/ReserveBonus'

import {
    EFFECT_ON_USE_TITLE,
    EFFECT_ON_USE_DESCRIPTION,
    ADDITIONAL_EFFECT_ON_USE_TITLE,
    ADDITIONAL_EFFECT_ON_USE_DESCRIPTION,
} from 'helpers/i18n.jsx'

import styles from './ReserveTooltipBody.scss'

export const ReserveTooltipBody = ({ reserveType, level, reserveInfo, isClientParametersVisible = true }) => {
    const bonusValuesArray = Object.values(reserveInfo.bonus.values[level - 1].battle_types)

    const mainEffectDescription = EFFECT_ON_USE_DESCRIPTION[reserveType]
    const additionalEffectDescription = ADDITIONAL_EFFECT_ON_USE_DESCRIPTION[reserveType]

    return (
        <reactFragment>
            <div className={styles.ribbon}>
                {isClientParametersVisible && mainEffectDescription && (
                    <reactFragment>
                        <div className={cx(styles.sectionTitle, styles.sectionTitle__effect)}>
                            {EFFECT_ON_USE_TITLE}
                        </div>
                        <div className={styles.effectDescription}>
                            {mainEffectDescription}
                        </div>
                    </reactFragment>
                )}
                <ReserveBonus
                    reserveInfo={reserveInfo}
                    level={level}
                    nextLevel={level}
                    layoutType='tooltip'
                    isClientParametersVisible={isClientParametersVisible}
                />
            </div>
            {isClientParametersVisible && additionalEffectDescription && (
                <reactFragment>
                    <div className={cx(styles.sectionTitle, styles.sectionTitle__additionalEffect)}>
                        {ADDITIONAL_EFFECT_ON_USE_TITLE}
                    </div>
                    {bonusValuesArray.map((value, index) => (
                        <div className={styles.parameter} key={index}>
                            <div className={styles.parameterValue}>{`+${value}`}</div>
                            <div className={styles.parameterDescription}>
                                {additionalEffectDescription}
                            </div>
                        </div>
                    ))}
                </reactFragment>
            )}
        </reactFragment>
    )
}

ReserveTooltipBody.propTypes = {
    reserveType: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    reserveInfo: PropTypes.object.isRequired,
    isClientParametersVisible: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./components/ReserveTooltip/components/ReserveTooltipBody.jsx